export default __webpack_public_path__ + "static/NJSOMA 2024 1(2) 74 to 76-927b1569db0237f8946fa48d43b98b72.pdf";